import QuestionLayout from "./QuestionLayout";

export default function DefinitionMatchingWidget({
  id,
  config,
  value = {},
  onChange,
  mode,
  feedback
}) {
  function setAnswer(termId, v) {
    if (mode === "review") return;

    // allow empty (backspace)
    if (v === "") {
      onChange({
        ...value,
        [termId]: ""
      });
      return;
    }

    // block non-digits
    if (!/^\d+$/.test(v)) return;

    onChange({
      ...value,
      [termId]: Number(v)
    });
  }

  return (
    <QuestionLayout
      number={config.number}
      prompt={config.prompt}
      points={config.points}
      mode={mode}
      feedback={feedback}
    >
      <div style={{ display: "flex", gap: 40, color: "#000" }}>
        {/* ───────── TERMS ───────── */}
        <div>
          {config.terms.map(term => {
            const part = feedback?.parts?.[term.id];
            const isReview = mode === "review";
            const isCorrect = part?.correct === true;
            const isIncorrect = part?.correct === false;

            return (
              <div
                key={term.id}
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: 10
                }}
              >
                <input
                  value={value[term.id] ?? ""}
                  disabled={isReview}
                  onChange={e =>
                    setAnswer(term.id, e.target.value)
                  }
                  style={{
                    width: 50,
                    marginRight: 10,
                    textAlign: "center",

                    /* ───── REVIEW STYLING ───── */
                    border: isReview ? "2px solid" : undefined,
                    borderRadius: isReview ? 4 : undefined,
                    borderColor: isCorrect
                      ? "#2e7d32"
                      : isIncorrect
                      ? "#c62828"
                      : undefined,
                    backgroundColor: isCorrect
                      ? "#e8f5e9"
                      : isIncorrect
                      ? "#fdecea"
                      : undefined
                  }}
                />

                <div style={{ width: 160 }}>
                  {term.label}
                </div>
              </div>
            );
          })}
        </div>

        {/* ───────── DEFINITIONS ───────── */}
        <div>
          {config.definitions.map(def => (
            <div
              key={def.number}
              style={{
                display: "flex",
                marginBottom: 8
              }}
            >
              <div
                style={{
                  width: 30,
                  fontWeight: "bold"
                }}
              >
                {def.number}.
              </div>

              <div style={{ maxWidth: 420 }}>
                {def.text}
              </div>
            </div>
          ))}
        </div>
      </div>
    </QuestionLayout>
  );
}
